import router from './router'
import { delCookie, getCookie } from './utils/cookie' // getToken from cookie
import  defines from './api'

// const whiteList = ['/index', '/moreAddrOrder','/guessLike','/newAddress','/addressList'] // no redirect whitelist
const whiteList = []
let uid = getCookie('hdu');
let hdt = getCookie('hdt');
let ua = navigator.userAgent.toLowerCase();
let loginurl  = defines.loginurl;
let wechaturl = defines.wechaturl;
let alipayurl = defines.alipayurl;
let alipayoauth2url = 'https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2017080308014832&scope=auth_user&redirect_uri=';
let oauth2url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx05d6a1410a2236e1&redirect_uri='; //正式环境
// let oauth2url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxaa2aa6cc330cd7bf&connect_redirect=1&redirect_uri='; //测试环境
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title
	if(uid || hdt) { // determine if there has token
		/* has token*/
		console.log(to.path, 'to.path')
		if(to.path === '/login') {
			next({
				path: '/center'
			})
		} else {
			next()
		}

	} else {
		/* has no token*/
		if(whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
			next()
		} else {
			var currenturl = window.location.href;
			if(currenturl.indexOf('?') < 0) {
				currenturl += "?";
			} else {
				currenturl += "&";
			}
			if(ua.match(/MicroMessenger/i) == "micromessenger") {
				//   	console.log("wechaturl: "+wechaturl + "||| currenturl: "+currenturl );
				var redirectUrl = encodeURIComponent(wechaturl + currenturl);
				//   	console.log("redirectUrl"+redirectUrl);
				var resultUrl = oauth2url + redirectUrl + "&response_type=code&scope=snsapi_base&state=login#wechat_redirect";
				window.location.href = resultUrl;
			} else if(ua.indexOf("alipay") >= 0) {
				var redirectUrl = encodeURIComponent(alipayurl + '&scope=auth_user,auth_zhima');
				var resultUrl = alipayoauth2url + redirectUrl;
				window.location.href = resultUrl;
			} else {
				window.location.href = loginurl + currenturl;
			}
		}
	}

})



// WEBPACK FOOTER //
// ./src/permission.js